import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cinema-search-page" }
const _hoisted_2 = { class: "go-back" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "qh-icon-back" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "cinema-search-page-tabs-wrap" }

import { onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import ElTabs, { ElTabPane } from 'element-plus/es/components/tabs'
import { useCinemaSearch } from '@remote/store/cinemaSearch'
import CinemaSearchList from '@remote/components/cinema/CinemaSearchList.vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['clickTvItem'],
  setup(__props, { emit }) {



const router = useRouter()
const { data, setSearchClass, cleanSearchPhase } = useCinemaSearch()
const handleOnGoback = () => {
  router.go(-1)
  cleanSearchPhase()
}

onUnmounted(cleanSearchPhase)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", { onClick: handleOnGoback }, _hoisted_5),
      _withDirectives(_createElementVNode("p", null, _toDisplayString(`共${_unref(data).filesNums.all}个“${_unref(data).phase}”相关影片结果`), 513), [
        [_vShow, _unref(data).phase]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(ElTabs), {
        class: "cinema-search-page-tabs",
        modelValue: _unref(data).class,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).class) = $event)),
        onTabChange: _unref(setSearchClass)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTabPane), {
            name: "all",
            label: `全部${_unref(data).filesNums.all > 0 ? '(' + _unref(data).filesNums.all + ')' : ''}`
          }, {
            default: _withCtx(() => [
              _createVNode(CinemaSearchList, {
                type: "all",
                onClickTvItem: _cache[0] || (_cache[0] = ($event: any) => (emit('clickTvItem')))
              })
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(ElTabPane), {
            name: "movie",
            label: `电影${_unref(data).filesNums.movie > 0 ? '(' + _unref(data).filesNums.movie + ')' : ''}`
          }, {
            default: _withCtx(() => [
              _createVNode(CinemaSearchList, { type: "movie" })
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(ElTabPane), {
            name: "tv",
            label: `电视剧${_unref(data).filesNums.tv > 0 ? '(' + _unref(data).filesNums.tv + ')' : ''}`
          }, {
            default: _withCtx(() => [
              _createVNode(CinemaSearchList, {
                type: "tv",
                onClickTvItem: _cache[1] || (_cache[1] = ($event: any) => (emit('clickTvItem')))
              })
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(ElTabPane), {
            name: "other",
            label: `其他${_unref(data).filesNums.other > 0 ? '(' + _unref(data).filesNums.other + ')' : ''}`
          }, {
            default: _withCtx(() => [
              _createVNode(CinemaSearchList, { type: "other" })
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue", "onTabChange"])
    ])
  ]))
}
}

})